import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useAuth } from '../../context/Auth';
import { useLayout } from '../../context/Layout';
import { mensagemErro } from '../../components/Layout';
import api from '../../api';

function AuthCallback() {
    const location = useLocation();
    const history = useHistory();
    const { setUser } = useAuth();
    const { isScreenLogin } = useLayout();

    useEffect(() => {
        isScreenLogin(true);
        return () => isScreenLogin(false);
    }, [isScreenLogin]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const dataBase64 = params.get('data');
        const error = params.get('error');

        if (dataBase64) {

            try {
                const jsonString = atob(dataBase64);
                const user = JSON.parse(jsonString);

                if (user.finished) {
                    api.defaults.headers.Authorization = `Bearer ${user.token}`

                    setUser({
                        id: user.id,
                        refresh: user.refresh || user.id,
                        nome: user.nome,
                        email: user.email,
                        avatar: user.avatar,
                        token: user.token,
                        finished: user.finished
                    })

                    history.push('/dash');
                } else {
                    history.push(`/cadastro`, { googleUser: user });
                }

            } catch (err) {
                mensagemErro('Falha ao processar dados de autenticação.')
                history.push('/');
            }

        } else if (error) {
            mensagemErro('Login cancelado ou não autorizado.');
            history.push('/');
        } else {
            history.push('/');
        }
    }, [location, history, setUser]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <p>Processando login...</p>
        </div>
    );
}

export default AuthCallback;
